import { createSlice } from '@reduxjs/toolkit';

const fileSlice = createSlice({
	name: 'filesManage',
	initialState: {
		files: []
	},
	reducers: {
		addFiles(state, action) {
			const newFiles = action.payload;
			state.files = [...state.files, ...newFiles];
		},
		removeFile(state, action) {
			const fileName = action.payload; //recive the fileName as id
			state.files = state.files.filter(
				(file) => file.name !== fileName
			);
		},
		removeAllFiles(state) {
			state.files = [];
		}
	}
});

export const fileActions = fileSlice.actions;

export default fileSlice;
